import  { useEffect, useState } from "react";
import {
  CommonHeader,
  ConfirmationModal,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../components/commons";
import { SearchIcon, UserIcon } from "../../components/Icon";
import { RootState } from "../../redux/rootReducers";
import { connect } from "react-redux";
import { resetSession } from "../../redux/auth";
import {
  resetFixedAssetHistoryData,
  resetFixedAssetRegisterError,
  resetFixedAssetRegisterListing,
  resetFixedAssetRegisterMessage,
  resetFixedAssetRegisterStatusCode,
  resetFixedAssetRegisterSuccess,
  resetFixedAssetRegisterTotalCount,
  resetFixedAssetUsersHistoryData,
  resetSingleFixedAsset,
} from "../../redux/fixedAsset";
import {
  deleteFixedAssetRegisterAction,
  getFARUsersHistoryAction,
  getFixedAssetHistoryAction,
  getFixedAssetRegisterListing,
} from "../../redux/fixedAsset/actions";
import FixedAssetTable from "../../components/FixedAssetRegister/FixedAssetTable/FixedAssetTable";
import { FIXED_ASSET_HEADERS } from "../../constant/tableHeadersConstants/fixedAssetConstant/fixedAssetHeaders";
import {
  BulkUploadIcon,
  EmptyClientList,
  NewDownloadIcon,
} from "../../assets/images";
import useDebounce from "../../customHooks/useDebounce";
import { getAllBusinessAddressAction } from "../../redux/clientSettings";
import { GetAllBussinessAddressesListPayloadType } from "../../commonTypes/clientSettingsTypes";
import { FixedAssetHistoryPayloadType, GetFARUsersHistoryPayloadType } from "../../commonTypes/fixedAssetRegisterTypes";
import { Link } from "react-router-dom";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import FixedAssetSorting from "../../components/FixedAssetRegister/FixedAssetRegisterSortingFilter/FixedAssetSorting";
import FixedAssetFilter from "../../components/FixedAssetRegister/FixedAssetRegisterSortingFilter/FixedAssetFilter";
import FixedAssetHistory from "../../components/FixedAssetRegister/FixedAssetRegisterSortingFilter/FixedAssetHistory";
import { downloadFixedAssetReportApi } from "../../apis/fixedAssetRegisterApi";
import FileSaver from "file-saver";
import toast from "react-hot-toast";
import { currentDate, reverseDate } from "../../utils/commonFunctions";
import { FixedAssetUsersHistoryData } from "../../redux/fixedAsset/fixedAssetRegisterTypes";
type AppProps = {
  history: any;
  token: string | null;
  message: string | null;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  fetching: boolean;
  fixedAssetHistorFetching: boolean;
  fixedAssetHistoryData: any;
  dispatchResetSession: () => void;
  dispatchResetFixedAssetRegisterError: () => void;
  dispatchResetFixedAssetRegisterListing: () => void;
  dispatchResetFixedAssetRegisterSuccess: () => void;
  dispatchGetFixedAssetRegisterListing: (data: any) => void;
  finacAssetListing: [];
  dispatchDeleteFixedAssetRegisterAction: (data: any) => void;
  dispatchResetFixedAssetRegisterMessage: () => void;
  dispatchResetFixedAssetRegisterTotalCount: () => void;
  dispatchResetFixedAssetRegisterStatusCode: () => void;
  dispatchResetFixedAssetHistoryData: () => void;
  dispatchResetSingleFixedAsset: () => void;
  totalCount: number;
  dispatchGetAllBusinessAddressAction: (
    data: GetAllBussinessAddressesListPayloadType
  ) => void;
  dispatchGetFixedAssetHistoryAction: (
    data: FixedAssetHistoryPayloadType
  ) => void;
  loctionList: any | null;
  dispatchGetFARUsersHistory: (data: GetFARUsersHistoryPayloadType) => void;
  dispatchResetFixedAssetUsersHistoryData:()=>void;
  fixedAssetUsersHistoryData: FixedAssetUsersHistoryData[] | [];
  assetHistoryFetching:boolean;


};

interface FilterConditionData {
  Obsolete: boolean;
  Missing: boolean;
  Good: boolean;
  Bad: boolean;
  qr: boolean;
}

const FixedAssetRegister = ({
  history,
  token,
  statusCode,
  success,
  message,
  fetching,
  fixedAssetHistorFetching,
  error,
  dispatchResetSession,
  dispatchResetFixedAssetRegisterError,
  dispatchResetFixedAssetRegisterSuccess,
  dispatchResetFixedAssetRegisterListing,
  dispatchGetFixedAssetRegisterListing,
  finacAssetListing,
  dispatchDeleteFixedAssetRegisterAction,
  dispatchResetFixedAssetRegisterMessage,
  dispatchResetFixedAssetRegisterTotalCount,
  dispatchResetFixedAssetRegisterStatusCode,
  totalCount,
  dispatchGetAllBusinessAddressAction,
  loctionList,
  dispatchGetFixedAssetHistoryAction,
  fixedAssetHistoryData,
  dispatchResetFixedAssetHistoryData,
  dispatchResetSingleFixedAsset,
  dispatchGetFARUsersHistory,
  dispatchResetFixedAssetUsersHistoryData,
  fixedAssetUsersHistoryData,
  assetHistoryFetching
}: AppProps) => {
  const client_code = history?.location?.state?.client_code;
  const persistFilterData = history?.location?.state?.filterData;
  const company_name =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.company_name
      ? history.location.state.company_name
      : "";
  const persistSearch = history?.location?.state?.searchValue
    ? history?.location?.state?.searchValue
    : "";
  const [searchValue, setSearchValue] = useState(persistSearch);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);

  const [isEditFixedAssetPresent, setIsEditFixedAssetPresent] = useMenuCheck();
  const [isAddFixedAssetPresent, setIsAddFixedAssetPresent] = useMenuCheck();
  const [isDeleteFixedAssetPresent, setIsDeleteFixedAssetPresent] =
    useMenuCheck();
  const [isBulkUploadFixedAssetPresent, setIsBulkUploadFixedAssetPresent] =
    useMenuCheck();

  const [listData, setListData] = useState<any>([]);
  const [data, setData] = useState<any>([]);
  const [sortByLocation, setSortByLocation] = useState({ name: "", value: "" });
  const [sortByDeparment, setSortByDeparment] = useState({
    name: "",
    value: "",
  });
  const [sortByCf, setSortByCf] = useState({ name: "", value: "" });
  const [sortByRecent, setSortByRecent] = useState({ name: "", value: "" });
  const [sortByOldest, setSortByOldest] = useState({ name: "", value: "" });
  const [assetId, setAssetId] = useState<null | number>(null);
  const [toggle, setToggle] = useState<boolean>(false);

  const [multiSelectData, setMultiSelectData] = useState<any>({
    Obsolete: "",
    Missing: "",
    Good: "",
    Bad: "",
    to_capitalize: "",
  });
  const [locationListValue, setLocationValue] = useState<any>([]);
  const [selectLoction, setSelectLoction] = useState<any>({
    label: "Select",
    value: null,
    logo: "",
  });

  const [locationSearch, setLocationSearch] = useState("");
  const clientCode = history?.location?.state?.client_code;
  const [filterConditionData, setFilterConditionData] = useState<any>({
    Obsolete: false,
    Missing: false,
    Good: false,
    Bad: false,
    to_capitalize: false,
    // qr: false,
  });
  const [qrcodeToggle, setQRCodeToggle] = useState(0);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [multiFilterMaintain, setMultiFilterMaintain] = useState({
    Obsolete: false,
    Missing: false,
    Good: false,
    Bad: false,
    to_capitalize: false,
    qrCode: 0,
    location: {
      label: "Select",
      value: null,
      logo: "",
    },
  });
  const [auditHistoryData, setAuditHistoryData] = useState({
    finacAssetId: "",
    description: "",
  });

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    setOffset(0);

    setIsEditFixedAssetPresent("Edit Fixed Asset", "menu");
    setIsAddFixedAssetPresent("Add Fixed Asset", "menu");
    setIsBulkUploadFixedAssetPresent("BulkUpload Fixed Asset", "menu");
    setIsDeleteFixedAssetPresent("Delete Fixed Asset", "menu");
    dispatchResetSingleFixedAsset();
    dispatchResetFixedAssetRegisterListing();
    dispatchResetFixedAssetRegisterSuccess();
    dispatchResetFixedAssetRegisterMessage();
    dispatchResetFixedAssetRegisterTotalCount();
    dispatchResetFixedAssetRegisterStatusCode();
    dispatchResetFixedAssetRegisterError();
    dispatchResetFixedAssetUsersHistoryData();

    setData([
      { name: "", value: "" },
      { name: "Location - A to Z", value: "asc" },
      { name: "Location - Z to A", value: "desc" },
      { name: "Department - A to Z", value: "asc" },
      { name: "Department - Z to A", value: "desc" },
    ]);
    if (persistFilterData) {
      setOffset(0);
      setSearchValue(persistFilterData?.searchValue);
      setSelectLoction({
        label: persistFilterData?.selectLoction?.label,
        value: persistFilterData?.selectLoction?.value,
        logo: persistFilterData?.selectLoction?.logo,
      });
      setFilterConditionData(() => {
        return {
          ...persistFilterData?.filterConditionData,
        };
      });
      if (persistFilterData?.sortByDeparment?.name) {
        handleSort(persistFilterData?.sortByDeparment);
      } else if (persistFilterData?.sortByLocation?.name?.length) {
        handleSort(persistFilterData?.sortByLocation);
      } else if (persistFilterData?.sortByOldest?.name) {
        handleSort(persistFilterData?.sortByOldest);
      } else {
        handleSort({ name: "", value: "" });
      }
      if (persistFilterData?.qrcodeToggle) {
        setQRCodeToggle(1);
      } else {
        setQRCodeToggle(0);
      }
      setMultiFilterMaintain({
        Obsolete: persistFilterData?.filterConditionData?.Obsolete,
        Missing: persistFilterData?.filterConditionData?.Missing,
        Good: persistFilterData?.filterConditionData?.Good,
        Bad: persistFilterData?.filterConditionData?.Bad,
        to_capitalize: persistFilterData?.filterConditionData?.to_capitalize,
        qrCode: persistFilterData?.qrcodeToggle,
        location: {
          label: persistFilterData?.selectLoction?.label,
          value: persistFilterData?.selectLoction?.value,
          logo: persistFilterData?.selectLoction?.logo,
        },
      });
    }
  }, []);

  useEffect(() => {
    setMultiSelectData((prev: any) => {
      return {
        Obsolete: filterConditionData?.Obsolete
          ? filterConditionData?.Obsolete
          : "",
        Missing: filterConditionData?.Missing
          ? filterConditionData?.Missing
          : "",
        Good: filterConditionData?.Good ? filterConditionData?.Good : "",
        Bad: filterConditionData?.Bad ? filterConditionData?.Bad : "",
        to_capitalize: filterConditionData?.to_capitalize
          ? filterConditionData?.to_capitalize
          : "",
      };
    });
  }, [finacAssetListing]);

  useEffect(() => {
    if (loctionList?.length) {
      let newData = loctionList?.map((item: any) => {
        return {
          label: item?.trade_name,
          value: item?.ledger_id,
          gstIn: item?.gst_number,
          legalName: item?.legal_name,
          logo: item?.logo_details,
        };
      });
      setLocationValue([...newData]);
    }
  }, [loctionList]);

  useEffect(() => {
    if (finacAssetListing?.length === 0) {
      setListData(finacAssetListing);
    } else if (offset > 0 && finacAssetListing?.length > 0 && !fetching) {
      setListData((prv: any) => [...prv, ...finacAssetListing]);
    } else {
      setListData(finacAssetListing);
    }
  }, [finacAssetListing]);

  useEffect(() => {
    dispatchResetFixedAssetRegisterStatusCode();
    dispatchResetFixedAssetRegisterSuccess();
    dispatchResetFixedAssetRegisterMessage();
    dispatchResetFixedAssetRegisterError();
    const trueKeys: string[] = Object.keys(filterConditionData).filter(
      (key) => filterConditionData[key] === true
    );
    const resultString = trueKeys.join(",");
    const persistTrueKeys: string[] =
      persistFilterData &&
      Object.keys(persistFilterData?.filterConditionData).filter(
        (key) => persistFilterData?.filterConditionData[key] === true
      );
    const persistResultString =
      persistTrueKeys?.length && persistTrueKeys.join(",");
    let finalData = {
      token,
      client_code,
      sort_by: persistFilterData?.sortByLocation?.name
        ? "location"
        : sortByLocation?.name
        ? "location"
        : persistFilterData?.sortByDeparment?.name
        ? "department"
        : sortByDeparment?.name
        ? "department"
        : persistFilterData?.sortByDeparment?.name
        ? "updated_at"
        : sortByOldest?.name
        ? "updated_at"
        : "",
      sort_by_value: sortByLocation?.value
        ? sortByLocation?.value
        : sortByDeparment?.value
        ? sortByDeparment?.value
        : sortByOldest?.value
        ? sortByOldest?.value
        : persistFilterData?.sortByLocation?.value
        ? persistFilterData?.sortByLocation?.value
        : persistFilterData?.sortByDeparment?.value
        ? persistFilterData?.sortByDeparment?.value
        : persistFilterData?.sortByOldest?.value
        ? persistFilterData?.sortByOldest?.value
        : "",
      searchValue: searchValue ? searchValue : persistFilterData?.searchValue,
      condition: resultString
        ? resultString
        : persistResultString
        ? persistResultString
        : "",
      limit,
      offset,
      location: selectLoction?.value
        ? selectLoction?.value
        : persistFilterData?.selectLoction?.value,
      qr_code:
        persistFilterData?.qrcodeToggle === 1 ? 0 : qrcodeToggle === 1 ? 0 : "",
    };

    if (totalCount) {
      if (offset < totalCount) {
        dispatchGetFixedAssetRegisterListing(finalData);
      }
    } else {
      dispatchGetFixedAssetRegisterListing(finalData);
    }
  }, [sortByLocation, sortByDeparment, offset, sortByOldest]);

  useEffect(() => {
    if (!showConfirmationModal) {
      setAssetId(null);
    }
  }, [showConfirmationModal]);

  useEffect(() => {
    if (token && clientCode && token) {
      let finatData = {
        token,
        search_term: locationSearch,
        client_code: clientCode,
      };
      dispatchGetAllBusinessAddressAction(finatData);
    }
  }, [locationSearch]);

  const fetchNewData = (search: string) => {
    if (token && searchValue) {
      dispatchResetFixedAssetRegisterStatusCode();
      dispatchResetFixedAssetRegisterSuccess();
      dispatchResetFixedAssetRegisterMessage();
      dispatchResetFixedAssetRegisterError();
      const trueKeys: string[] = Object.keys(filterConditionData).filter(
        (key) => filterConditionData[key] === true
      );
      const resultString = trueKeys.join(",");
      let finalData = {
        token,
        client_code,
        sort_by: sortByLocation?.name
          ? "location"
          : sortByDeparment?.name
          ? "department"
          : sortByOldest?.name
          ? "updated_at"
          : "",
        sort_by_value: sortByLocation?.value
          ? sortByLocation?.value
          : sortByDeparment?.value
          ? sortByDeparment?.value
          : sortByOldest?.value
          ? sortByOldest?.value
          : "",
        searchValue: searchValue,
        condition: resultString,
        limit,
        offset,
        location: selectLoction?.value ? selectLoction?.value : "",
        qr_code: qrcodeToggle === 1 ? 0 : "",
      };
      dispatchGetFixedAssetRegisterListing(finalData);
    }
  };
  useDebounce(
    () => {
      if (searchValue) {
        fetchNewData(searchValue);
      }
    },
    500,
    [searchValue]
  );
  const handleApplyFilterData = () => {
    setMultiFilterMaintain({
      Obsolete: filterConditionData?.Obsolete,
      Missing: filterConditionData?.Missing,
      Good: filterConditionData?.Good,
      Bad: filterConditionData?.Bad,
      to_capitalize: filterConditionData?.to_capitalize,
      qrCode: qrcodeToggle,
      location: {
        label: selectLoction?.label,
        value: selectLoction?.value,
        logo: selectLoction?.logo,
      },
    });
    setMultiSelectData([
      filterConditionData?.Obsolete,
      filterConditionData?.Missing,
      filterConditionData?.Good,
      filterConditionData?.Bad,
      filterConditionData?.to_capitalize,
    ]);
    if (token) {
      dispatchResetFixedAssetRegisterListing();
      dispatchResetFixedAssetRegisterSuccess();
      dispatchResetFixedAssetRegisterMessage();
      dispatchResetFixedAssetRegisterTotalCount();
      dispatchResetFixedAssetRegisterStatusCode();
      dispatchResetFixedAssetRegisterError();

      if (offset === 0) {
        const trueKeys: string[] = Object.keys(filterConditionData).filter(
          (key) => filterConditionData[key] === true
        );
        const resultString = trueKeys.join(",");
        let finalData = {
          token,
          client_code,
          sort_by: sortByLocation?.name
            ? "location"
            : sortByDeparment?.name
            ? "department"
            : sortByOldest?.name
            ? "updated_at"
            : "",
          sort_by_value: sortByLocation?.value
            ? sortByLocation?.value
            : sortByDeparment?.value
            ? sortByDeparment?.value
            : sortByOldest?.value
            ? sortByOldest?.value
            : "",
          searchValue: searchValue,
          condition: resultString,
          limit,
          offset,
          location: selectLoction?.value ? selectLoction?.value : "",
          qr_code: qrcodeToggle === 1 ? 0 : "",
        };
        dispatchGetFixedAssetRegisterListing(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  const clearFilter = () => {
    if (history?.location?.state) {
      const newState = { ...history.location.state };
      delete newState.filterData;
      history.replace({
        ...history.location,
        state: newState,
      });
    }

    setFilterConditionData(() => {
      return {
        Obsolete: false,
        Missing: false,
        Good: false,
        Bad: false,
        to_capitalize: false,
      };
    });
    setQRCodeToggle(0);
    setMultiSelectData([]);
    setSelectLoction({
      label: "Select",
      value: null,
      logo: "",
    });
    if (offset === 0) {
      let finalData = {
        token,
        client_code,
        sort_by: sortByLocation?.name
          ? "location"
          : sortByDeparment?.name
          ? "department"
          : sortByOldest?.name
          ? "updated_at"
          : "",
        sort_by_value: sortByLocation?.value
          ? sortByLocation?.value
          : sortByDeparment?.value
          ? sortByDeparment?.value
          : sortByOldest?.value
          ? sortByOldest?.value
          : "",
        searchValue: searchValue,
        limit,
        offset,
      };
      dispatchGetFixedAssetRegisterListing(finalData);
    } else {
      setOffset(0);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetFixedAssetRegisterError();
            }}
          />
        );
      }
    }
    if (
      success === 1 &&
      message === "Fixed asset has been deleted successfully!"
    ) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={message}
          buttonText="OK"
          onPress={() => {
            dispatchResetFixedAssetRegisterListing();
            dispatchResetFixedAssetRegisterSuccess();
            dispatchResetFixedAssetRegisterMessage();
            dispatchResetFixedAssetRegisterTotalCount();
            dispatchResetFixedAssetRegisterStatusCode();
            dispatchResetFixedAssetRegisterError();
            if (token) {
              if (offset === 0) {
                if (token) {
                  const trueKeys: string[] = Object.keys(
                    filterConditionData
                  ).filter((key) => filterConditionData[key] === true);
                  const resultString = trueKeys.join(",");
                  let finalData = {
                    token,
                    client_code,
                    sort_by: sortByLocation?.name
                      ? "location"
                      : sortByDeparment?.name
                      ? "department"
                      : "",
                    sort_by_value: sortByLocation?.value
                      ? sortByLocation?.value
                      : sortByDeparment?.value
                      ? sortByDeparment?.value
                      : "",
                    searchValue: searchValue,
                    condition: resultString,
                    limit,
                    offset,
                    location: selectLoction?.value ? selectLoction?.value : "",
                    qr_code: qrcodeToggle === 1 ? 0 : "",
                  };
                  dispatchGetFixedAssetRegisterListing(finalData);
                }
              } else {
                dispatchResetFixedAssetRegisterListing();
                setOffset(0);
              }
            }
            dispatchResetFixedAssetRegisterSuccess();
          }}
        />
      );
    }
  };

  const handleLoctionChange = (e: any) => {
    setSelectLoction({
      label: e.label,
      value: e.value,
      logo: e?.logo?.file_url,
    });
  };

  const handleConfirmationModal = () => {
    setShowConfirmationModal(!showConfirmationModal);
  };

  const handleSort = (data: any) => {
    setOffset(0);
    if (
      data?.name === "Department - A to Z" ||
      data?.name === "Department - Z to A"
    ) {
      setSortByDeparment(data);
      setSortByLocation({ name: "", value: "" });
      setSortByOldest({ name: "", value: "" });
      setSortByRecent({ name: "", value: "" });
    } else if (
      data?.name === "Location - Z to A" ||
      data?.name === "Location - A to Z"
    ) {
      setSortByLocation(data);
      setSortByDeparment({ name: "", value: "" });
      setSortByRecent({ name: "", value: "" });
      setSortByOldest({ name: "", value: "" });
    } else if (data?.name === "Oldest first") {
      setSortByOldest(data);
      setSortByDeparment({ name: "", value: "" });
      setSortByRecent({ name: "", value: "" });
      setSortByLocation({ name: "", value: "" });
    } else if (data?.name === "Newest first") {
      setSortByLocation({ name: "", value: "" });
      setSortByDeparment({ name: "", value: "" });
      setSortByCf({ name: "", value: "" });
      setSortByOldest({ name: "", value: "" });
      setSortByRecent(data);
    }
  };

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setOffset(0);
    setSearchValue(value);
    if (value?.length === 0) {
      if (history?.location?.state) {
        const newState = { ...history.location.state };
        delete newState?.filterData?.searchValue;
        history.replace({
          ...history.location,
          state: newState,
        });
      }
      const trueKeys: string[] = Object.keys(filterConditionData).filter(
        (key) => filterConditionData[key] === true
      );
      const resultString = trueKeys.join(",");
      let finalData = {
        token,
        client_code,
        sort_by: sortByLocation?.name
          ? "location"
          : sortByDeparment?.name
          ? "department"
          : sortByOldest?.name
          ? "updated_at"
          : "",
        sort_by_value: sortByLocation?.value
          ? sortByLocation?.value
          : sortByDeparment?.value
          ? sortByDeparment?.value
          : sortByOldest?.value
          ? sortByOldest?.value
          : "",
        searchValue: value,
        condition: resultString,
        limit,
        offset,
        location: selectLoction?.value ? selectLoction?.value : "",
        qr_code: qrcodeToggle === 1 ? 0 : "",
      };
      dispatchGetFixedAssetRegisterListing(finalData);
    }
  };

  const handleDeleteData = (data: any) => {
    setAssetId(data);
  };

  const handleDeleteAsset = () => {
    if (assetId) {
      let finalData = {
        token,
        client_code,
        asset_id: assetId,
      };
      dispatchDeleteFixedAssetRegisterAction(finalData);
    }
    handleConfirmationModal();
  };

const handleRemoveData =()=>{
  dispatchResetFixedAssetUsersHistoryData()
}
  const handleShowAssetUser =(data:any)=>{
    if (token && data?.id) {
      dispatchResetFixedAssetUsersHistoryData();
      const finalData = {
        token,
        farId: data?.id,
      };
      dispatchGetFARUsersHistory(finalData);
    }

  }
  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < +totalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (finacAssetListing?.length > 0) {
          if (!fetching && offset < +totalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [finacAssetListing]);

  const handleHistoryFixedAssetModule = (data: any) => {
    dispatchResetFixedAssetHistoryData();
    setAuditHistoryData({
      finacAssetId: data?.finac_asset_id,
      description: data?.asset_description,
    });
    if (token && data?.id) {
      const finalData = {
        token,
        fixedAssetId: data?.id,
      };
      dispatchGetFixedAssetHistoryAction(finalData);
    }
    setShowHistoryModal(true);
  };

  const handleHistoryModal = () => {
    setShowHistoryModal(!showHistoryModal);
  };

  const handlePrepareDownload = () => {
    const trueKeys: string[] = Object.keys(filterConditionData).filter(
      (key) => filterConditionData[key] === true
    );

    const resultString = trueKeys.join(",");

    let params: any = {
      client_code,
      condition: resultString,
      location: selectLoction?.value ? selectLoction?.value : "",
      token,
      search_term: searchValue ? searchValue : persistFilterData?.searchValue,
      qr_code:
        persistFilterData?.qrcodeToggle === 1 ? 0 : qrcodeToggle === 1 ? 0 : "",
      sort_by: sortByLocation?.name
        ? "location"
        : sortByDeparment?.name
        ? "department"
        : sortByOldest?.name
        ? "updated_at"
        : "",
      sort_by_value: sortByLocation?.value
        ? sortByLocation?.value
        : sortByDeparment?.value
        ? sortByDeparment?.value
        : sortByOldest?.value
        ? sortByOldest?.value
        : "",
    };

    if (params && token) {
      handleDownload(params);
    }
  };
  const handleDownload = (params: any) => {
    let reportName = `FAR_${client_code}_${reverseDate(currentDate())}.xlsx`;

    downloadFixedAssetReportApi(params)
      .then((response: any) => {
        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
        });
        FileSaver.saveAs(blob, reportName);
        toast.success("Report Downloaded Successfully!", {
          duration: 3000,
        });
      })
      .catch((error: any) => {
        toast.success(error, {
          duration: 3000,
        });
      });
  };
  return (
    <>
      <div className="row mb-3">
        <div className="col-md-4">
          <CommonHeader title="Fixed Asset Register" />
          <div className="d-flex align-items-center ml-2">
            {client_code ? (
              <>
                <UserIcon /> &nbsp;
                {company_name} {"(" + client_code + ")"}
              </>
            ) : null}
          </div>
        </div>
      </div>
      <div className="new-table-card pt-4">
        <div className="row">
          <div className="col-md-12 d-flex justify-content-between">
            <div className="col-md-3 ml-3" style={{ padding: 0 }}>
              <div
                className="d-flex flex-column"
                style={{ justifyContent: "center", alignItems: "flex-start" }}
              >
                <h6 style={{ fontSize: "18px", fontWeight: 500 }}>
                  Fixed Asset Register Listing
                </h6>
                <div
                  style={{
                    color: "rgb(124, 141, 176)",
                    fontSize: "13px",
                    fontWeight: 500,
                  }}
                >
                  Total {totalCount} records found
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end col-md-9">
              <div className="col-md-4">
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={handleSearch}
                  style={{ paddingLeft: "35px" }}
                  value={searchValue}
                />
              </div>

              {isBulkUploadFixedAssetPresent && (
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 250 }}
                  overlay={
                    <Tooltip id="button-view-open-item">Bulk Upload</Tooltip>
                  }
                >
                  <div className="ml-2">
                    <Link
                      onClick={() => {
                        dispatchResetFixedAssetRegisterSuccess();
                        dispatchResetFixedAssetRegisterError();
                        dispatchResetFixedAssetRegisterMessage();
                        dispatchResetFixedAssetRegisterStatusCode();
                      }}
                      to={`/fixed-asset-register/bulk-upload/${client_code}?company=${company_name}`}
                      className="mr-2 d-flex align-items-center justify-content-center pointer"
                      style={{
                        border: "1px solid #ced4da",
                        borderRadius: "0.25rem",
                      }}
                    >
                      <div className="pointer p-2">
                        <img src={BulkUploadIcon} alt="img" />
                        <span
                          className="ml-1"
                          style={{ color: "black", fontWeight: "500" }}
                        >
                          Bulk Upload
                        </span>
                      </div>
                    </Link>
                  </div>
                </OverlayTrigger>
              )}

              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 250 }}
                overlay={<Tooltip id="button-view-open-item">Sorting</Tooltip>}
              >
                <div>
                  <FixedAssetSorting
                    data={data}
                    handleChange={handleSort}
                    selectedData={
                      sortByLocation?.value
                        ? sortByLocation
                        : sortByDeparment?.value
                        ? sortByDeparment
                        : sortByOldest?.value
                        ? sortByOldest
                        : sortByCf
                    }
                    history={history}
                  />
                </div>
              </OverlayTrigger>

              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 250 }}
                overlay={<Tooltip id="button-view-open-item">Filter</Tooltip>}
              >
                <div className=" ml-2">
                  <FixedAssetFilter
                    toggle={toggle}
                    setToggle={setToggle}
                    locationListValue={locationListValue}
                    selectLoction={selectLoction}
                    handleLoctionChange={handleLoctionChange}
                    filterConditionData={filterConditionData}
                    setFilterConditionData={setFilterConditionData}
                    handleApplyFilterData={handleApplyFilterData}
                    clearFilter={clearFilter}
                    setMultiSelectData={setMultiSelectData}
                    multiSelectData={multiSelectData}
                    setQRCodeToggle={setQRCodeToggle}
                    qrCodeToggle={qrcodeToggle}
                    multiFilterMaintain={multiFilterMaintain}
                    setSelectLoction={setSelectLoction}
                    setMultiFilterMaintain={setMultiFilterMaintain}
                    history={history}
                  />
                </div>
              </OverlayTrigger>

              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 250 }}
                overlay={
                  <Tooltip id="button-view-download">Download Reports</Tooltip>
                }
              >
                <div className="ml-2">
                  <button
                    className="btn"
                    style={{ border: "1px solid #bfcbe1" }}
                    onClick={() => handlePrepareDownload()}
                  >
                    <img src={NewDownloadIcon} alt="download icon" />
                  </button>
                </div>
              </OverlayTrigger>

              <div className="ml-2 mr-4 d-flex justify-content-end">
                {isAddFixedAssetPresent && (
                  <div className="justify-content-end">
                    <button
                      onClick={() =>
                        history?.push({
                          pathname: `/fixed-asset-register/fixed-asset-register-list/${client_code}/add`,
                          state: { client_code, company_name },
                        })
                      }
                      className="btn btn-primary"
                    >
                      + Add Asset
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {fetching && offset === 0  ? (
          <TableLoader Rows={10} ColumnPerRow={7} />
        ) : listData?.length > 0 ? (
          <FixedAssetTable
            offset={offset}
            fetching={fetching}
            history={history}
            clientCode={client_code}
            handleConfirmationModal={handleConfirmationModal}
            handleDeleteData={handleDeleteData}
            finacAssetListing={listData}
            tableHeader={FIXED_ASSET_HEADERS}
            persistData={{
              qrcodeToggle,
              selectLoction,
              filterConditionData,
              searchValue,
              sortByLocation,
              sortByDeparment,
              sortByOldest,
            }}
            handleHistoryFixedAssetModule={handleHistoryFixedAssetModule}
            isEditFixedAssetPresent={isEditFixedAssetPresent}
            isDeleteFixedAssetPresent={isDeleteFixedAssetPresent}
            handleShowAssetUser={handleShowAssetUser}
            fixedAssetUsersHistoryData={fixedAssetUsersHistoryData}
            assetHistoryFetching={assetHistoryFetching}
            handleRemoveData={handleRemoveData}
          />
        ) : (
          fetching === false &&
          listData?.length === 0 && (
            <div className="mt-5">
              <EmptyListPage
                title="No Fixed Asset List Found"
                image={EmptyClientList}
                imageWidth="30%"
              />
            </div>
          )
        )}
      </div>
      {showConfirmationModal && (
        <ConfirmationModal
          toggle={() => {
            handleConfirmationModal();
          }}
          isOpen={showConfirmationModal}
          title={`Delete Asset from the List?`}
          message={`Are you sure you want to delete asset with Finac Asset ID ${assetId}?`}
          confirmButtonText={"Delete"}
          onPressConfirm={() => {
            handleDeleteAsset();
          }}
        />
      )}
      {showHistoryModal && (
        <FixedAssetHistory
          handleHistoryModal={handleHistoryModal}
          showHistoryModal={showHistoryModal}
          fetching={fixedAssetHistorFetching}
          fixedAssetHistoryData={fixedAssetHistoryData}
          auditHistoryData={auditHistoryData}
        />
      )}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.fixedAssetRegister.success,
  fetching: state.fixedAssetRegister.fetching,
  message: state.fixedAssetRegister.message,
  statusCode: state.fixedAssetRegister.statusCode,
  error: state.fixedAssetRegister.error,
  finacAssetListing: state.fixedAssetRegister.finacAssetListing,
  totalCount: state.fixedAssetRegister.totalCount,
  loctionList: state.clientSettings.businessAddressList,
  fixedAssetHistoryData: state.fixedAssetRegister.fixedAssetHistoryData,
  fixedAssetHistorFetching: state.fixedAssetRegister.fixedAssetHistorFetching,
  fixedAssetUsersHistoryData:
  state.fixedAssetRegister.fixedAssetUsersHistoryData,
  assetHistoryFetching:state.fixedAssetRegister.assetHistoryFetching
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetFixedAssetRegisterSuccess: () =>
    dispatch(resetFixedAssetRegisterSuccess()),
  dispatchResetFixedAssetRegisterListing: () =>
    dispatch(resetFixedAssetRegisterListing()),
  dispatchGetFixedAssetRegisterListing: (data: any) =>
    dispatch(getFixedAssetRegisterListing(data)),
  dispatchResetFixedAssetRegisterError: () =>
    dispatch(resetFixedAssetRegisterError()),
  dispatchDeleteFixedAssetRegisterAction: (data: any) =>
    dispatch(deleteFixedAssetRegisterAction(data)),
  dispatchResetFixedAssetRegisterMessage: () =>
    dispatch(resetFixedAssetRegisterMessage()),
  dispatchResetFixedAssetRegisterStatusCode: () =>
    dispatch(resetFixedAssetRegisterStatusCode()),
  dispatchResetFixedAssetRegisterTotalCount: () =>
    dispatch(resetFixedAssetRegisterTotalCount()),
  dispatchGetAllBusinessAddressAction: (data: any) =>
    dispatch(getAllBusinessAddressAction(data)),
  dispatchGetFixedAssetHistoryAction: (data: FixedAssetHistoryPayloadType) =>
    dispatch(getFixedAssetHistoryAction(data)),
  dispatchResetFixedAssetHistoryData: () =>
    dispatch(resetFixedAssetHistoryData()),
  dispatchResetSingleFixedAsset: () => dispatch(resetSingleFixedAsset()),
  dispatchGetFARUsersHistory: (data: GetFARUsersHistoryPayloadType) =>
    dispatch(getFARUsersHistoryAction(data)),
  dispatchResetFixedAssetUsersHistoryData: () =>
    dispatch(resetFixedAssetUsersHistoryData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FixedAssetRegister);
